import { Plus } from 'lucide-react';
import { type PaymentMethodTranslations } from './types';

interface AddCardButtonProps {
  t: PaymentMethodTranslations;
  onClick: () => void;
}

export function AddCardButton({ t, onClick }: AddCardButtonProps) {
  return (
    <button
      onClick={onClick}
      className="w-full flex items-center justify-center gap-2 bg-background border border-secondary text-secondary rounded py-2.5 transition-colors hover:bg-secondary/5"
    >
      <Plus className="w-4 h-4" />
      <span className="text-sm">{t.addCard}</span>
    </button>
  );
}
